Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Replit", {
  enumerable: true,
  get: function get() {
    return _replit.Replit;
  }
});
var _replit = require("./replit");